// src/pages/WinLogPage.tsx
import React, { useState, useEffect } from 'react';
import { scoringApi } from '../api';
import type { WinDay } from '../types';

export default function WinLogPage() {
  const [wins, setWins]       = useState<WinDay[]>([]);
  const [total, setTotal]     = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    scoringApi.getWinLog()
      .then(d => { setWins(d.wins); setTotal(d.totalWins); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div style={{ fontSize:26, fontWeight:600, letterSpacing:-0.5, marginBottom:6 }}>Win Log</div>
      <div style={{ fontSize:12, color:'var(--text3)', fontFamily:'var(--font-mono)', marginBottom:24 }}>
        Days where all 3 priority habits were done and zero break slips
      </div>

      {loading ? (
        <div style={{ color:'var(--text3)', fontSize:12, fontFamily:'var(--font-mono)' }}>loading...</div>
      ) : wins.length === 0 ? (
        <div className="card" style={{ textAlign:'center', padding:48 }}>
          <div style={{ fontSize:32, marginBottom:12 }}>🏆</div>
          <div style={{ fontSize:14, color:'var(--text2)' }}>No wins yet — keep going!</div>
          <div style={{ fontSize:11, color:'var(--text3)', marginTop:8 }}>
            Complete all 3 priority habits in a day with no break habit slips to earn a win.
          </div>
        </div>
      ) : (
        <>
          <div className="card" style={{ marginBottom:20, display:'inline-block', padding:'10px 20px' }}>
            <span style={{ fontFamily:'var(--font-mono)', fontSize:28, fontWeight:700, color:'var(--green)' }}>
              {total}
            </span>
            <span style={{ fontSize:12, color:'var(--text3)', marginLeft:8 }}>total wins</span>
          </div>

          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {wins.map(w => (
              <div key={w.date} className="card" style={{
                borderLeft:'3px solid var(--green)',
                background:'var(--green-dim)',
                borderTopColor:'rgba(0,229,160,0.2)',
                borderRightColor:'rgba(0,229,160,0.2)',
                borderBottomColor:'rgba(0,229,160,0.2)',
              }}>
                <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                  <span style={{ fontSize:20 }}>🏆</span>
                  <div>
                    <div style={{
                      fontFamily:'var(--font-mono)', fontSize:13,
                      fontWeight:600, color:'var(--green)',
                    }}>
                      {new Date(w.date + 'T00:00:00').toLocaleDateString('en-GB', {
                        weekday:'long', day:'numeric', month:'long', year:'numeric',
                      })}
                    </div>
                    <div style={{ fontSize:10, color:'var(--text3)', marginTop:3 }}>
                      {w.habitNames.join(' · ')}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
